import { useCallback } from 'react'

import { EditorPanelItem, ElementsPanelConfig } from '@editor/interfaces/editor'
import { InspectionArea } from '@editor/interfaces/inspection'
import { getVolumeEstimationItems } from '@editor/services/VolumeEstimation'
import { RootState } from '@editor/store/app'
import { useSelector } from 'react-redux'

const useVolumeDetection = (): ElementsPanelConfig => {
  // Store
  const inspectionItems = useSelector((state: RootState) => state.inspectionItems.items)
  const checkedEditorElements = useSelector((state: RootState) => state.blueprint.drawings.document.editorElements)

  return {
    getPanelItems: useCallback(
      (parent?: EditorPanelItem['item'], area?: InspectionArea): EditorPanelItem[] => {
        // Volume is parent-level item, ignore if a parent is provided
        if (parent) return []

        const volumes = getVolumeEstimationItems(
          inspectionItems.filter((item) => !area || item.inspection_area_id === area.inspection_area_id),
        )

        if (volumes.length === 0) return []

        return [
          {
            key: 'panel-volume',
            name: '体積',
            isVirtualContainer: true,
            isCountable: true,
            children: [
              // Saved volumes
              ...volumes.map<EditorPanelItem>((item, index) => ({
                key: `panel-volume-${item.inspection_item_id!}`,
                name: item.part_name || `体積 ${index + 1}`,
                item,
                order: item.order_in_inspection_group,
                isGrouped: !!item.inspection_group_id,
                isOrderable: false,
                isCountable: false,
                isCheckable: true,
                isChecked: checkedEditorElements.inspectionItems.some((row) => row.id === item.inspection_item_id),
                onDelete: false,
                onHover: true,
              })),
            ],
          },
        ]
      },
      [inspectionItems, checkedEditorElements.inspectionItems],
    ),
  }
}

export default useVolumeDetection
